export default __webpack_public_path__ + "static/media/gray-cross.f9409202.svg";